import { footerColumns } from "@/mocks/homeData";

export default function SiteFooter() {
  return (
    <footer className="w-full bg-secondary-800 text-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 pt-14 md:pt-16 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-8 md:gap-10">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="w-10 h-10 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center text-xl">
                <i className="ri-flashlight-fill"></i>
              </span>
              <span className="font-heading text-xl font-bold text-background-50">黑料官方</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-background-200">
              一个围绕线索分享与理性讨论的社区。这里聚合黑料官方联系方式、客服邮箱与官方入口，
              让有料要曝的人和想咨询的人都能少走弯路。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              {["官方入口", "匿名投稿", "客服邮箱"].map((tag) => (
                <span
                  key={tag}
                  className="rounded-full border border-white/20 px-3 py-1 text-xs text-background-100"
                >
                  {tag}
                </span>
              ))}
            </div>
          </div>

          {footerColumns.map((column) => (
            <div key={column.title} className="lg:col-span-2">
              <h3 className="font-heading text-base font-bold text-background-50">{column.title}</h3>
              <ul className="mt-4 space-y-2.5">
                {column.links.map((link) => (
                  <li key={link}>
                    <a
                      href="#channels"
                      className="text-sm text-background-200 hover:text-primary-300 transition-colors cursor-pointer"
                    >
                      {link}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div className="lg:col-span-1">
            <h3 className="font-heading text-base font-bold text-background-50">入口</h3>
            <ul className="mt-4 space-y-2.5">
              <li>
                <a href="#channels" className="text-sm text-background-200 hover:text-primary-300 transition-colors cursor-pointer">
                  直达
                </a>
              </li>
              <li>
                <a href="#contact" className="text-sm text-background-200 hover:text-primary-300 transition-colors cursor-pointer">
                  邮箱
                </a>
              </li>
              <li>
                <a href="#faq" className="text-sm text-background-200 hover:text-primary-300 transition-colors cursor-pointer">
                  问答
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 md:mt-12 rounded-lg border border-white/15 bg-black/15 p-5 md:p-6">
          <div className="flex items-start gap-2.5">
            <i className="ri-shield-check-line text-accent-300 text-lg shrink-0"></i>
            <p className="text-xs md:text-sm leading-relaxed text-background-200">
              <strong className="font-medium text-background-100">免责声明：</strong>
              本页仅整理官方联系方式与入口信息，页面内容为演示展示。涉及他人的信息请遵守法律法规与平台规范，
              不传播未经核实的内容，不侵犯他人合法权益。
            </p>
          </div>
        </div>

        <div className="mt-8 flex flex-col sm:flex-row items-center justify-between gap-4 border-t border-white/15 pt-6">
          <p className="text-xs md:text-sm text-background-300">
            © 2026 黑料官方 · 保留所有权利
          </p>
          <div className="flex flex-wrap items-center justify-center gap-5 text-xs md:text-sm text-background-200">
            <a href="#top" className="hover:text-primary-300 transition-colors cursor-pointer">
              返回顶部
            </a>
            <a href="#contact" className="hover:text-primary-300 transition-colors cursor-pointer">
              联系方式
            </a>
            <a href="#faq" className="hover:text-primary-300 transition-colors cursor-pointer">
              常见问题
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}